import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { AdminMenuBigComponent } from './admin-menu-big.component';
import { RouterModule } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    TranslateModule,
    IonicModule,
    CommonModule,
    RouterModule,
    AngularSvgIconModule,
  ],
  declarations: [AdminMenuBigComponent],
  exports: [AdminMenuBigComponent],
})
export class AdminMenuBigModule {}
